  function normalizeCompareText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '_');
  }

  function normalizeCompareCategoryData(source, fallbackCategory) {
    const provedeni = normalizeCompareText(source.provedeni || source.productProvedeni || '');
    const provedeniADesign = normalizeCompareText(source.provedeni_a_design || source.productProvedeniADesign || '');
    const category = normalizeCompareText(fallbackCategory || source.compare_category || source.productCompareCategory || '');
    const kategoriePristroju = normalizeCompareText(source.kategorie_pristroju || source.productKategoriePristroju || '');
    const title = normalizeCompareText(source.title || source.productTitle || '');
    const handle = normalizeCompareText(source.handle || source.productHandle || '');
    const design = normalizeCompareText(source.design || source.productDesign || '');
    const designHodnoty = normalizeCompareText(source.design_hodnoty || source.productDesignHodnoty || '');

    if (
      category.includes('zehlici_pristroje') ||
      category.includes('zehlici_pristroj') ||
      category.includes('zehlici_systemy') ||
      category.includes('zehlici_system') ||
      category.includes('mandly') ||
      category.includes('mandl') ||
      title.includes('zehlici_pristroj') ||
      title.includes('zehlici_system') ||
      title.includes('mandl') ||
      title.includes('fashionmaster') ||
      handle.includes('b_990') ||
      handle.includes('b_995') ||
      handle.includes('b_3312') ||
      handle.includes('b_4312') ||
      handle.includes('b_4826') ||
      handle.includes('b_4847') ||
      design.includes('barva_zehlicky') ||
      design.includes('barva_zehliciho_potahu') ||
      designHodnoty.includes('barva_zehlicky') ||
      designHodnoty.includes('barva_zehliciho_potahu')
    ) return 'zehlici_pristroje';
    if (
  category.includes('pracky_se_susickou') ||
  category.includes('pracka_se_susickou') ||
  title.includes('pracky_se_susickou') ||
  title.includes('pracka_se_susickou') ||
  handle.includes('pracky_se_susickou') ||
  handle.includes('pracka_se_susickou') ||
  String(source.trida_energeticke_ucinnosti_prani_a_suseni_a_g || '').trim() !== '' ||
  String(source.productTridaEnergetickeUcinnostiPraniASuseniAG || '').trim() !== ''
) return 'pracky_se_susickou';

if (
  category.includes('pracky') ||
  category.includes('pracka') ||
  category.includes('pracky_pradla') ||
  category.includes('pracka_pradla') ||
  category.includes('automaticke_pracky') ||
  category.includes('automaticka_pracka') ||
  title.includes('pracka') ||
  title.includes('pracky') ||
  handle.includes('ww_') ||
  handle.includes('wwd') ||
  handle.includes('wwg') ||
  handle.includes('wwi') ||
  handle.includes('wwk') ||
  handle.includes('wwr') ||
  handle.includes('wwv') ||
  handle.includes('wq_') ||
  handle.includes('wq1') ||
  provedeni.includes('pracka_s_prednim_plnenim') ||
  provedeni.includes('pracka_s_hornim_plnenim') ||
  provedeni.includes('pracka') ||
  provedeniADesign.includes('pracka_s_prednim_plnenim') ||
  provedeniADesign.includes('pracka_s_hornim_plnenim') ||
  provedeniADesign.includes('pracka')
) return 'pracky';

if (
  category.includes('profesionalni_mycka') ||
      category.includes('profesionalni_mycky') ||
      category.includes('profesionalni_mycky_nadobi') ||
      category.includes('profesionalni_mycky_na_nadobi') ||
      category.includes('profi_mycka') ||
      category.includes('profi_mycky') ||
      title.includes('profesionalni_mycka') ||
      title.includes('profesionalni_mycky') ||
      title.includes('professional_mycka') ||
      title.includes('professional_mycky') ||
      title.includes('pfd_')
    ) return 'profesionalni_mycky';
    if (
      category.includes('kavovar') ||
      category.includes('kavovary') ||
      title.includes('kavovar') ||
      handle.includes('cva') ||
      provedeniADesign.includes('vestavny_kavovar_s_mlynkem_na_kavu') ||
      provedeniADesign.includes('volne_stojici_kavovar_s_mlynkem_na_kavu')
    ) return 'kavovary';
    if (
      category.includes('vinoteka') ||
      category.includes('vinoteky') ||
      title.includes('vinoteka') ||
      title.includes('chladnicka_na_vino') ||
      handle.includes('kwt')
    ) return 'vinoteky';
        if (
      category.includes('chladnicka') ||
      category.includes('chladnicky') ||
      category.includes('kombinace_chladnicky_s_mraznickou') ||
      kategoriePristroju.includes('chladnicka') ||
      kategoriePristroju.includes('chladnicky') ||
      kategoriePristroju.includes('kombinace_chladnicky_s_mraznickou') ||
      title.includes('chladnicka') ||
      title.includes('chladnicky') ||
      handle.includes('ks_') ||
      handle.includes('kfn_') ||
      handle.includes('kdn_')
    ) return 'chladnicky';
        if (
      category.includes('mraznicka') ||
      category.includes('mraznicky') ||
      title.includes('mraznicka') ||
      title.includes('mraznicky') ||
      title.includes('mrazici_skrin') ||
      title.includes('mrazici_skrine') ||
      handle.includes('fn_') ||
      handle.includes('fns_') ||
      handle.includes('f_')
    ) return 'mraznicky';
    if (
      category.includes('mycka') ||
      category.includes('mycky') ||
      title.includes('mycka')
    ) return 'mycky';
    if (
      category.includes('mraznicka') ||
      category.includes('mraznicky') ||
      title.includes('mraznicka') ||
      title.includes('mraznicky') ||
      title.includes('mrazici_skrin') ||
      title.includes('mrazici_skrine') ||
      handle.includes('fn_') ||
      handle.includes('fns_') ||
      handle.includes('f_')
    ) return 'mraznicky';
    if (
      category.includes('varne_desky') ||
      category.includes('varna_deska') ||
      title.includes('varne_desky') ||
      title.includes('varna_deska') ||
      title.includes('smartline') ||
      title.includes('proline') ||
      handle.includes('km_') ||
      handle.includes('kmda') ||
      handle.includes('cs_') ||
      provedeni.includes('indukcni_varna_deska') ||
      provedeni.includes('plynova_varna_deska') ||
      provedeni.includes('smartline') ||
      provedeni.includes('proline') ||
      provedeniADesign.includes('indukcni_varna_deska') ||
      provedeniADesign.includes('plynova_varna_deska') ||
      provedeniADesign.includes('smartline') ||
      provedeniADesign.includes('proline')
    ) return 'varne_desky';

    if (provedeni.includes('vestavna_mikrovlnna_trouba') || provedeni.includes('volne_stojici_mikrovlnna_trouba') || provedeniADesign.includes('vestavna_mikrovlnna_trouba') || provedeniADesign.includes('volne_stojici_mikrovlnna_trouba')) return 'mikrovlnne_trouby';
   if (category.includes('konvektomaty') || category.includes('konvektomat') || category.includes('parni_trouba') || title.includes('konvektomat') || title.includes('parni_trouba') || provedeni.includes('konvektomat') || provedeni.includes('konvektomaty') || provedeni.includes('vestavna_parni_trouba') || provedeniADesign.includes('konvektomat') || provedeniADesign.includes('vestavna_parni_trouba') || provedeniADesign.includes('parni_trouba_s_mikrovlnou')) return 'konvektomaty';
    if (title.includes('pecici_trouba') || title.includes('pecici_trouby') || provedeni.includes('vestavna_pecici_trouba') || provedeni.includes('vestavna_pecici_trouba_s_mikrovlnou') || provedeniADesign.includes('vestavna_pecici_trouba') || provedeniADesign.includes('vestavna_pecici_trouba_s_mikrovlnou')) return 'pecici_trouby';

    if (provedeni.includes('akumulatorovy_vysavac')) return 'tycove_akumulatorove_vysavace';
    if (provedeni.includes('bezsackovy_podlahovy_vysavac')) return 'bezsackove_vysavace';
    if (provedeni.includes('sackovy_podlahovy_vysavac')) return 'sackove_vysavace';
    if (provedeni.includes('odsavac') || provedeni.includes('digestor') || provedeni.includes('digestore')) return 'odsavace';

    if (
      String(source.trida_energeticke_ucinnosti_prani_a_suseni_a_g || '').trim() !== '' ||
      String(source.productTridaEnergetickeUcinnostiPraniASuseniAG || '').trim() !== ''
    ) {
      return 'pracky_se_susickou';
    }

    return category || 'pracky';
  }

  window.getCompareItems = function() {
    try {
      const items = JSON.parse(localStorage.getItem('product_compare_items_v2')) || [];

      return items.map(function(item) {
        item.compare_category = normalizeCompareCategoryData(item, item.compare_category);
        return item;
      });
    } catch (e) {
      return [];
    }
  };

function updateCompareButtons(compareItems) {
  const activeIds = new Set(
    compareItems.map(function(item) {
      return String(item.id);
    })
  );

  document.querySelectorAll('[data-compare-product].is-added').forEach(function(button) {
    if (!activeIds.has(String(button.dataset.productId))) {
      button.classList.remove('is-added');
    }
  });

  activeIds.forEach(function(productId) {
    document
      .querySelectorAll('[data-compare-product][data-product-id="' + productId + '"]')
      .forEach(function(button) {
        if (!button.classList.contains('is-added')) {
          button.classList.add('is-added');
        }
      });
  });
}

function updateCompareCount(compareItems) {
  const count = compareItems.length;

  document.querySelectorAll('[data-compare-count]').forEach(function(el) {
    if (count > 0) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.hidden = false;
      el.classList.remove('is-hidden');
    } else {
      el.textContent = '';
      el.hidden = true;
      el.classList.add('is-hidden');
    }
  });
}

function refreshCompareUi() {
  const compareItems = window.getCompareItems();

  updateCompareButtons(compareItems);
  updateCompareCount(compareItems);
}

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-compare-product]');
    if (!button) return;

   const product = {
  id: String(button.dataset.productId),
  handle: button.dataset.productHandle,
  title: button.dataset.productTitle,
  oznaceni_modelu: button.dataset.productOznaceniModelu || button.dataset.productTitle || '',
cislo_materialu_vyrobce: button.dataset.productCisloMaterialuVyrobce || '',
cislo_ean: button.dataset.productCisloEan || '',
cislo_stareho_materialu: button.dataset.productCisloStarehoMaterialu || '',
marketingova_trida: button.dataset.productMarketingovaTrida || '',
druh_ohrevu: button.dataset.productDruhOhrevu || '',
vseobecne_udaje: button.dataset.productVseobecneUdaje || '',
vseobecne_udaje_hodnoty: button.dataset.productVseobecneUdajeHodnoty || '',
kategorie_pristroju: button.dataset.productKategoriePristroju || '',
  url: button.dataset.productUrl,
  image: button.dataset.productImage,
  compare_category: normalizeCompareCategoryData({
    title: button.dataset.productTitle || '',
        handle: button.dataset.productHandle || '',
    compare_category: button.dataset.productCompareCategory || '',
    provedeni: button.dataset.productProvedeni || '',
    provedeni_a_design: button.dataset.productProvedeniADesign || '',
    kategorie_pristroju: button.dataset.productKategoriePristroju || '',
    design: button.dataset.productDesign || '',
    design_hodnoty: button.dataset.productDesignHodnoty || '',
    trida_energeticke_ucinnosti_prani_a_suseni_a_g: button.dataset.productTridaEnergetickeUcinnostiPraniASuseniAG || button.dataset.productTridaEnergetickeUcinnostiPraniASuseni || ''
  }, button.dataset.productCompareCategory || ''),

provedeni: button.dataset.productProvedeni || '',
provedeni_hodnota: button.dataset.productProvedeniHodnota || '',
provedeni_a_design: button.dataset.productProvedeniADesign || '',
provedeni_a_design_hodnota: button.dataset.productProvedeniADesignHodnota || '',
uzivatelske_vyhody: button.dataset.productUzivatelskeVyhody || '',
uzivatelske_vyhody_hodnota: button.dataset.productUzivatelskeVyhodyHodnota || '',
parni_technologie_privod_vody: button.dataset.productParniTechnologiePrivodVody || '',
parni_technologie_privod_vody_hodnoty: button.dataset.productParniTechnologiePrivodVodyHodnoty || '',
provozni_zpusoby: button.dataset.productProvozniZpusoby || '',
provozni_zpusoby_hodnoty: button.dataset.productProvozniZpusobyHodnoty || '',
vybaveni_varnych_zon_hodnoty: button.dataset.productVybaveniVarnychZonHodnoty || '',
zpusob_vedeni_vzduchu: button.dataset.productZpusobVedeniVzduchu || '',
potrebna_sada_pro_prestavbu_na_cirkulaci_k_dokoupeni: button.dataset.productPotrebnaSadaProPrestavbuNaCirkulaciKDokoupeni || '',
potrebny_uhlikovy_filtr_k_dokoupeni: button.dataset.productPotrebnyUhlikovyFiltrKDokoupeni || '',
odtah_hodnoty: button.dataset.productOdtahHodnoty || '',
cirkulace_hodnoty: button.dataset.productCirkulaceHodnoty || '',
konstrukce: button.dataset.productKonstrukce || '',
odstredovani: button.dataset.productOdstredovani || '',
oznaceni_pristroje: button.dataset.productOznaceniPristroje || '',
oznaceni_produktu: button.dataset.productOznaceniProduktu || button.dataset.productOznaceniPristroje || '',
varianta_motoru: button.dataset.productVariantaMotoru || '',
typ_pristroje: button.dataset.productTypPristroje || '',
typ_produktu: button.dataset.productTypProduktu || '',


  maximalni_pocet_otacek: button.dataset.productMaximalniPocetOtacek || '',
  barva_pristroje: button.dataset.productBarvaPristroje || '',
  barva_ovladaciho_panelu: button.dataset.productBarvaOvladacihoPanelu || '',
  design_dvirek: button.dataset.productDesignDvirek || '',
  barva_otocneho_volice: button.dataset.productBarvaOtocnehoVolice || '',
  design_dvirek_a_ovladacich_panelu: button.dataset.productDesignDvirekAOvladacichPanelu || '',
  provedeni_ovladaciho_panelu: button.dataset.productProvedeniOvladacihoPanelu || '',
  zpusob_ovladani: button.dataset.productZpusobOvladani || '',
  displej: button.dataset.productDisplej || '',
  barva_displeje: button.dataset.productBarvaDispleje || '',
  design: button.dataset.productDesign || '',
  design_hodnoty: button.dataset.productDesignHodnoty || '',
  cistici_vykon: button.dataset.productCisticiVykon || '',
  cisteni: button.dataset.productCisteni || '',
  setrna_pece_o_pradlo: button.dataset.productSetrnaPeceOPradlo || '',
    setrna_pece_o_pradlo_hodnota: button.dataset.productSetrnaPeceOPradloHodnota || '',
  setrna_pece_o_pradlo_hodnoty: button.dataset.productSetrnaPeceOPradloHodnoty || button.dataset.productSetrnaPeceOPradloHodnota || '',

  hmotnost_naplne_v_kg: button.dataset.productHmotnostNaplneVKg || '',
hmotnost_naplne_pri_prani_v_kg: button.dataset.productHmotnostNaplnePriPraniVKg || '',
hmotnost_naplne_pri_suseni_v_kg: button.dataset.productHmotnostNaplnePriSuseniVKg || '',

komfort_pri_obsluze: button.dataset.productKomfortPriObsluze || '',
komfort_pri_obsluze_hodnoty: button.dataset.productKomfortPriObsluzeHodnoty || '',
napojove_speciality: button.dataset.productNapojoveSpeciality || '',
custom_napojove_speciality_hodnota: button.dataset.productCustomNapojoveSpecialityHodnota || '',
napojove_speciality_hodnota: button.dataset.productNapojoveSpecialityHodnota || button.dataset.productCustomNapojoveSpecialityHodnota || '',
snadne_zavirani_dvirek: button.dataset.productSnadneZaviraniDvirek || '',
indikator_provozu_kontrolni_funkce: button.dataset.productIndikatorProvozuKontrolniFunkce || '',
  stupne_vykonu_pocet_bez_intenzivniho_stupne: button.dataset.productStupneVykonuPocetBezIntenzivnihoStupne || '',
  intenzivni_stupne: button.dataset.productIntenzivniStupne || '',
  automaticka_funkce: button.dataset.productAutomatickaFunkce || '',
  elektronicka_regulace_vykonu: button.dataset.productElektronickaRegulaceVykonu || '',
  saci_trubice: button.dataset.productSaciTrubice || '',
  parkovaci_system_pro_uskladneni: button.dataset.productParkovaciSystemProUskladneni || '',
  mobilita: button.dataset.productMobilita || '',
  akcni_radius_v_m: button.dataset.productAkcniRadiusVM || '',
  delka_kabelu_v_m: button.dataset.productDelkaKabeluVM || '',
  filtracni_system: button.dataset.productFiltracniSystem || '',
  filtracni_system_hodnota: button.dataset.productFiltracniSystemHodnota || '',
  pocet_tukovych_filtru_z_nerezove_oceli_vhodnych_k_myti_v_mycce: button.dataset.productPocetTukovychFiltruZNerezoveOceliVhodnychKMytiVMycce || '',
  typ_sacku_do_vysavace: button.dataset.productTypSackuDoVysavace || '',
  objem_sacku_v_l: button.dataset.productObjemSackuVL || '',
  vzduchovy_filtr: button.dataset.productVzduchovyFiltr || '',
  objem_prachove_nadoby_v_l: button.dataset.productObjemPrachoveNadobyVL || '',
  typ_akumulatoru: button.dataset.productTypAkumulatoru || '',
  jmenovita_kapacita_akumulatoru_v_mah: button.dataset.productJmenovitaKapacitaAkumulatoruVMah || '',
  doba_provozu_na_stupen_min_powerunit_samostatne: button.dataset.productDobaProvozuNaStupenMinPowerunitSamostatne || '',
  doba_provozu_na_stupen_min_s_elektroprislusenstvim: button.dataset.productDobaProvozuNaStupenMinSElektroprislusenstvim || '',
  doba_provozu_na_stupen_max_s_elektroprislusenstvim: button.dataset.productDobaProvozuNaStupenMaxSElektroprislusenstvim || '',
  plosny_vykon_v_m: button.dataset.productPlosnyVykonVM || '',
  doba_nabijeni_v_min: button.dataset.productDobaNabijeniVMin || '',
  propojeni_s_miele_home: button.dataset.productPropojeniSMieleHome || '',
  parni_system_steamcare: button.dataset.productParniSystemSteamcare || '',
  predvolba_startu_az_24_hodin: button.dataset.productPredvolbaStartuAzDvacetCtyriHodin || '',
  indikace_zbyvajiciho_casu: button.dataset.productIndikaceZbyvajicihoCasu || '',
  indikace_prubehu_programu: button.dataset.productIndikacePrubehuProgramu || '',
  zobrazeni_denniho_casu: button.dataset.productZobrazeniDennihoCasu || '',
  informacni_texty: button.dataset.productInformacniTexty || '',
  oblibene_programy: button.dataset.productOblibeneProgramy || '',
  multilingua: button.dataset.productMultilingua || '',
  zasobnik_na_praci_prostredky_autoclean: button.dataset.productZasobnikNaPraciProstredkyAutoclean || '',
  addload: button.dataset.productAddload || '',
  comfortopen: button.dataset.productComfortopen || '',
  osvetleni_bubnu_led: button.dataset.productOsvetleniBubnuLed || '',

trida_energeticke_ucinnosti: button.dataset.productTridaEnergetickeUcinnosti || '',
trida_energeticke_ucinnosti_a_d: button.dataset.productTridaEnergetickeUcinnostiAD || '',
energeticka_trida: button.dataset.productEnergetickaTrida || '',
trida_energeticke_ucinnosti_prani_a_suseni_a_g: button.dataset.productTridaEnergetickeUcinnostiPraniASuseniAG || button.dataset.productTridaEnergetickeUcinnostiPraniASuseni || '',
uspornejsi_nez_mezni_hodnota_52_tridy_energeticke_ucinnosti_a: button.dataset.productUspornejsiNezMezniHodnotaPadesatDvaTridyEnergetickeUcinnostiA || '',
vazena_spotreba_elektricke_energie_na_100_cyklu_kwh: button.dataset.productVazenaSpotrebaElektrickeEnergieNaStoCykluKwh || '',
trida_ucinnosti_kondenzace_a_d: button.dataset.productTridaUcinnostiKondenzaceAD || '',
ucinnost_kondenzace_v: button.dataset.productUcinnostKondenzaceV || '',
vazena_spotreba_el_energie_na_100_mycich_sarzi_v_programu_eco_no: button.getAttribute('data-product-vazena-spotreba-el-energie-na-100-mycich-sarzi-v-programu-eco-no') || '',
emise_hluku_prenaseneho_vzduchem_ve_standardnim_programu_eco_nor: button.getAttribute('data-product-emise-hluku-prenaseneho-vzduchem-ve-standardnim-programu-eco-nor') || button.dataset.productEmiseHlukuPrenasenehoVzduchemVeStandardnimProgramuEcoNor || '',
trida_emisi_hluku_prenaseneho_vzduchem_a_d: button.dataset.productTridaEmisiHlukuPrenasenehoVzduchemAD || '',
doba_trvani_programu_eco_normal_v_min: button.dataset.productDobaTrvaniProgramuEcoNormalVMin || '',
vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_kompletni_provozni_cyklus_v_kwh: button.getAttribute('data-product-vazena-spotreba-elektricke-energie-na-100-provoznich-cyklu-pro-kompletni-provozni-cyklus-v-kwh') || '',
vazena_spotreba_elektricke_energie_na_100_provoznich_cyklu_pro_cyklus_prani_v_kwh: button.getAttribute('data-product-vazena-spotreba-elektricke-energie-na-100-provoznich-cyklu-pro-cyklus-prani-v-kwh') || '',
vazena_spotreba_vody_na_provozni_cyklus_v_l: button.dataset.productVazenaSpotrebaVodyNaProvozniCyklusVL || '',
vazena_spotreba_vody_na_provozni_cyklus_pro_cyklus_prani_v_l: button.dataset.productVazenaSpotrebaVodyNaProvozniCyklusProCyklusPraniVL || '',
vazena_spotreba_vody_na_provozni_cyklus_pro_kompletni_provozni_cyklus_v_l: button.dataset.productVazenaSpotrebaVodyNaProvozniCyklusProKompletniProvozniCyklusVL || '',
vykon_vyvijece_pary_kw: button.dataset.productVykonVyvijeceParyKw || '',
objem_zasobniku_na_cerstvou_vodu_l: button.dataset.productObjemZasobnikuNaCerstvouVoduL || '',
nocni_vypnuti: button.dataset.productNocniVypnuti || '',
nerezovy_povrch_cleansteel: button.dataset.productNerezovyPovrchCleansteel || '',
nerezovy_ohrevny_prostor: button.dataset.productNerezovyOhrevnyProstor || '',
dvirka_cleanglass: button.dataset.productDvirkaCleanglass || '',
prumer_otocneho_talire_v_cm: button.dataset.productPrumerOtocnehoTalireVCm || '',
vyska_ohrevneho_prostoru_v_cm: button.dataset.productVyskaOhrevnehoProstoruVCm || '',
maximalni_vykon_mikrovlny_ve_w: button.dataset.productMaximalniVykonMikrovlnyVeW || '',
vykon_grilu_ve_w: button.dataset.productVykonGriluVeW || '',
objem_ohrevneho_prostoru_l: button.dataset.productObjemOhrevnehoProstoruL || '',
zaves_dvirek: button.dataset.productZavesDvirek || '',
pocet_urovni_zasunuti: button.dataset.productPocetUrovniZasunuti || '',
osvetleni_ohrevneho_prostoru: button.dataset.productOsvetleniOhrevnehoProstoru || '',
typ_zasuvky: button.dataset.productTypZasuvky || '',
elektronicky_rizeny_vykon_mikrovlny: button.dataset.productElektronickyRizenyVykonMikrovlny || '',
minimalni_sirka_vyklenku_v_mm: button.dataset.productMinimalniSirkaVyklenkuVMm || '',
maximalni_sirka_vyklenku_v_mm: button.dataset.productMaximalniSirkaVyklenkuVMm || '',
minimalni_vyska_vyklenku_v_mm: button.dataset.productMinimalniVyskaVyklenkuVMm || '',
maximalni_vyska_vyklenku_v_mm: button.dataset.productMaximalniVyskaVyklenkuVMm || '',
hloubka_vyklenku_v_mm: button.dataset.productHloubkaVyklenkuVMm || '',
ventilace_nezavisle_na_vyklenku: button.dataset.productVentilaceNezavisleNaVyklenku || '',
pocet_fazi: button.dataset.productPocetFazi || '',
pripojovaci_kabel_se_zastrckou: button.dataset.productPripojovaciKabelSeZastrckou || '',
vymena_svitidel: button.dataset.productVymenaSvitidel || '',
pocet_urovni_zasunuti_ohrevny_prostor_1: button.getAttribute('data-product-pocet-urovni-zasunuti-ohrevny-prostor-1') || '',
pocet_urovni_zasunuti_ohrevny_prostor_2: button.getAttribute('data-product-pocet-urovni-zasunuti-ohrevny-prostor-2') || '',
teploty_ve_c: button.dataset.productTeplotyVeC || '',
minimalni_teploty_ve_c: button.dataset.productMinimalniTeplotyVeC || '',
maximalni_teploty_ve_c: button.dataset.productMaximalniTeplotyVeC || '',
minimalni_teploty_pri_provozu_parni_trouby_ve_c: button.dataset.productMinimalniTeplotyPriProvozuParniTroubyVeC || '',
maximalni_teploty_pri_provozu_parni_trouby_ve_c: button.dataset.productMaximalniTeplotyPriProvozuParniTroubyVeC || '',
minimalni_teploty_pri_provozu_pecici_trouby_ve_c: button.dataset.productMinimalniTeplotyPriProvozuPeciciTroubyVeC || '',
maximalni_teploty_pri_provozu_pecici_trouby_ve_c: button.dataset.productMaximalniTeplotyPriProvozuPeciciTroubyVeC || '',
teploty_pri_provozu_pecici_trouby_ve_c: button.dataset.productTeplotyPriProvozuPeciciTroubyVeC || '',
teploty_pri_provozu_parni_trouby_ve_c: button.dataset.productTeplotyPriProvozuParniTroubyVeC || '',
rozmery_vyklenku_s_x_v_x_h_v_mm: button.dataset.productRozmeryVyklenkuSXVXHVMm || '',
stupne_vykonu_mikrovlny_w: button.dataset.productStupneVykonuMikrovlnyW || '',
trida_energeticke_ucinnosti_odstredovani_a_g: button.dataset.productTridaEnergetickeUcinnostiOdstredovaniAG || '',
trida_urovne_emisi_hluku_pri_odstredovani_a_d: button.dataset.productTridaUrovneEmisiHlukuPriOdstredovaniAD || '',
uroven_emisi_hluku_pri_odstredovani_db_a: button.dataset.productUrovenEmisiHlukuPriOdstredovaniDbA || '',
delka_programu_eco_40_60_pri_jmenovite_kapacite: button.dataset.productDelkaProgramuEcoCtyricetSedesatPriJmenoviteKapacite || '',
delka_programu_pri_jmenovite_kapacite_pro_cyklus_prani: button.dataset.productDelkaProgramuPriJmenoviteKapaciteProCyklusPrani || '',
delka_programu_pri_jmenovite_kapacite_pro_kompletni_provozni_cyklus: button.dataset.productDelkaProgramuPriJmenoviteKapaciteProKompletniProvozniCyklus || '',
prikon_ve_vypnutem_stavu_ve_w: button.dataset.productPrikonVeVypnutemStavuVeW || button.dataset.productPrikonVeVypnutemStavuW || '',
prikon_v_pohotovostnim_rezimu_ve_w: button.dataset.productPrikonVPohotovostnimRezimuVeW || button.dataset.productPrikonVPohotovostnimRezimuW || '',
prikon_v_sitovem_pohotovostnim_rezimu_ve_w: button.dataset.productPrikonVSitovemPohotovostnimRezimuVeW || button.dataset.productPrikonVSitovemPohotovostnimRezimuW || '',
cas_do_automatickeho_zapnuti_z_vypnuteho_stavu_v_min: button.dataset.productCasDoAutomatickehoZapnutiZVypnutehoStavuVMin || '',
cas_do_automatickeho_zapnuti_z_pohotovostniho_rezimu_v_min: button.dataset.productCasDoAutomatickehoZapnutiZPohotovostnihoRezimuVMin || '',
cas_do_automatickeho_zapnuti_ze_sitoveho_pohotovostniho_rezimu_m: button.dataset.productCasDoAutomatickehoZapnutiZeSitovehoPohotovostnihoRezimuVMin || '',
trida_energeticke_ucinnosti_a_g: button.dataset.productTridaEnergetickeUcinnostiAG || button.dataset.productTridaEnergetickeUcinnosti || '',
spotreba_vody_v_programu_automatika_v_litrech_od: button.dataset.productSpotrebaVodyVProgramuAutomatikaVLitrechOd || '',
spotreba_vody_v_programu_eco_na_jeden_programovy_cyklus_v_l: button.dataset.productSpotrebaVodyVProgramuEcoNaJedenProgramovyCyklusVL || '',
spotreba_elektricke_energie_v_programu_eco_kwh: button.dataset.productSpotrebaElektrickeEnergieVProgramuEcoKwh || '',
spotreba_elektricke_energie_v_programu_eco_na_100_programovych_cyklu_kwh: button.getAttribute('data-product-spotreba-elektricke-energie-v-programu-eco-na-100-programovych-cyklu-kwh') || '',
hodnota_spotreby_s_pripojenim_na_teplou_vodu_v_programu_eco_v_kwh: button.getAttribute('data-product-hodnota-spotreby-s-pripojenim-na-teplou-vodu-v-programu-eco-v-kwh') || '',
delka_programu_eco_v_minutach: button.dataset.productDelkaProgramuEcoVMinutach || '',
pocet_jidelnich_souprav: button.dataset.productPocetJidelnichSouprav || '',
trida_akustickych_emisi: button.dataset.productTridaAkustickychEmisi || '',
akusticke_emise_v_db_a: button.dataset.productAkustickeEmiseVDbA || '',
hospodarnost_a_udrzitelnost: button.dataset.productHospodarnostAUdrzitelnost || '',
hospodarnost: button.dataset.productHospodarnostAUdrzitelnost || button.dataset.productHospodarnost || '',
hospodarnost_a_udrzitelnost_hodnota: button.dataset.productHospodarnostAUdrzitelnostHodnota || '',
hospodarnost_a_udrzitelnost_hodnoty: button.dataset.productHospodarnostAUdrzitelnostHodnoty || button.dataset.productHospodarnostAUdrzitelnostHodnota || '',
rocni_spotreba_energie_v_kwh_rok: button.getAttribute('data-product-rocni-spotreba-energie-v-kwh-rok') || '',
trida_ucinnosti_proudeni_kapalin: button.getAttribute('data-product-trida-ucinnosti-proudeni-kapalin') || '',
trida_ucinnosti_osvetleni: button.getAttribute('data-product-trida-ucinnosti-osvetleni') || '',
trida_ucinnosti_filtrace_tuku: button.getAttribute('data-product-trida-ucinnosti-filtrace-tuku') || '',
stupen_odlouceni_tuku: button.getAttribute('data-product-stupen-odlouceni-tuku') || '',

kvalita_vysledku: button.dataset.productKvalitaVysledku || '',
programy_myti: button.dataset.productProgramyMyti || '',
programy_myti_hodnoty: button.dataset.productProgramyMytiHodnoty || '',
moznosti_myti: button.dataset.productMoznostiMyti || '',
kosove_usporadani: button.dataset.productKosoveUsporadani || '',
kosove_usporadani_hodnota: button.dataset.productKosoveUsporadaniHodnota || '',
pouziti: button.dataset.productPouziti || '',
vykonove_udaje: button.dataset.productVykonoveUdaje || '',
vykonove_udaje_hodnota: button.dataset.productVykonoveUdajeHodnota || '',
ridici_jednotka: button.dataset.productRidiciJednotka || '',
ridici_jednotka_hodnota: button.dataset.productRidiciJednotkaHodnota || '',
ridici_jednotka_hodnoty: button.dataset.productRidiciJednotkaHodnoty || '',
chladici_zona: button.dataset.productChladiciZona || '',
chladici_zona_hodnoty: button.dataset.productChladiciZonaHodnoty || '',
mrazici_zona: button.dataset.productMraziciZona || '',
mrazici_zona_hodnoty: button.dataset.productMraziciZonaHodnoty || button.dataset.productMraziciZonaHodnota || '',
standardni_elektricke_pripojeni: button.dataset.productStandardniElektrickePripojeni || '',
standardni_elektricke_pripojeni_hodnota: button.dataset.productStandardniElektrickePripojeniHodnota || '',
mozna_varianta_napeti_1: button.getAttribute('data-product-mozna-varianta-napeti-1') || '',
mozna_varianta_napeti_1_hodnota: button.getAttribute('data-product-mozna-varianta-napeti-1-hodnota') || '',
pripojka_privodu_a_odvodu_vody: button.dataset.productPripojkaPrivoduAOdvoduVody || '',
pripojka_privodu_a_odvodu_vody_hodnota: button.dataset.productPripojkaPrivoduAOdvoduVodyHodnota || '',
rozmery_a_hmotnost: button.dataset.productRozmeryAHmotnost || '',
rozmery_a_hmotnost_hodnota: button.dataset.productRozmeryAHmotnostHodnota || '',
emisni_hodnoty: button.dataset.productEmisniHodnoty || '',
emisni_hodnoty_hodnota: button.dataset.productEmisniHodnotyHodnota || '',
moznosti_pripojeni: button.dataset.productMoznostiPripojeni || '',
normy_zkusebni_a_identifikacni_oznaceni: button.dataset.productNormyZkusebniAIdentifikacniOznaceni || '',
programy_prani: button.dataset.productProgramyPrani || '',
  programy_suseni: button.dataset.productProgramySuseni || '',
  vysledek_suseni: button.dataset.productVysledekSuseni || '',
    extra_funkce: button.dataset.productExtraFunkce || '',
  komfort_pri_udrzbe: button.dataset.productKomfortPriUdrzbe || '',
  komfort_pri_udrzbe_hodnoty: button.dataset.productKomfortPriUdrzbeHodnoty || '',
bezpecnost: button.dataset.productBezpecnost || '',
bezpecnost_hodnota: button.dataset.productBezpecnostHodnota || button.dataset.productBezpecnostHodnoty || '',
bezpecnost_hodnoty: button.dataset.productBezpecnostHodnoty || button.dataset.productBezpecnostHodnota || '',
system_chlazeni_pristroje_s_vlaznou_celni_stenou: button.dataset.productSystemChlazeniPristrojeSVlaznouCelniStenou || '',
zablokovani_zprovozneni: button.dataset.productZablokovaniZprovozneni || '',
bezpecnostni_vypinac: button.dataset.productBezpecnostniVypinac || '',
bezpecnostni_upozorneni_pri_nedovrenych_dvirkach: button.dataset.productBezpecnostniUpozorneniPriNedovrenychDvirkach || '',
technicke_udaje: button.dataset.productTechnickeUdaje || '',
technicke_udaje_hodnota: button.dataset.productTechnickeUdajeHodnota || '',
technicke_udaje_hodnoty: button.dataset.productTechnickeUdajeHodnoty || '',
osvetleni: button.dataset.productOsvetleni || '',
osvetleni_hodnota: button.dataset.productOsvetleniHodnota || '',
pocet_x_w: button.dataset.productPocetXW || '',
intenzita_osvetleni_v_lx: button.dataset.productIntenzitaOsvetleniVLx || '',
barevna_teplota_svetla_v_k: button.dataset.productBarevnaTeplotaSvetlaVK || '',
ventilator: button.dataset.productVentilator || '',
ventilator_hodnota: button.dataset.productVentilatorHodnota || '',
pocet_ventilatoru: button.dataset.productPocetVentilatoru || '',
montazni_pokyny: button.dataset.productMontazniPokyny || '',
montazni_pokyny_hodnota: button.dataset.productMontazniPokynyHodnota || '',
montazni_pokyny_hodnoty: button.dataset.productMontazniPokynyHodnoty || button.dataset.productMontazniPokynyHodnota || '',
instalacni_vykresy: button.dataset.productInstalacniVykresy || '',
prumer_odtahoveho_hrdla_v_mm: button.dataset.productPrumerOdtahovehoHrdlaVMm || '',
optimalni_kombinace_s_varnou_deskou_podle_dostupnosti: button.dataset.productOptimalniKombinaceSVarnouDeskouPodleDostupnosti || '',
kombinace_s_varnou_deskou_miele_podporujici_wifi: button.dataset.productKombinaceSVarnouDeskouMielePodporujiciWifi || '',
  system_ochrany_proti_poskozeni_vodou: button.dataset.productSystemOchranyProtiPoskozeniVodou || '',
  vykon_ve_wattech: button.dataset.productVykonVeWattech || '',
  hlasitost_v_db: button.dataset.productHlasitostVDb || '',
  sirka_v_mm: button.dataset.productSirkaVMm || '',
  vyska_v_mm: button.dataset.productVyskaVMm || '',
  hloubka_v_mm: button.dataset.productHloubkaVMm || '',
  dodavane_prislusenstvi: button.dataset.productDodavanePrislusenstvi || '',
dodavane_prislusenstvi_hodnota: button.dataset.productDodavanePrislusenstviHodnota || '',
dodavane_prislusenstvi_hodnoty: button.dataset.productDodavanePrislusenstviHodnoty || button.dataset.productDodavanePrislusenstviHodnota || '',
grilovaci_rost: button.getAttribute('data-product-grilovaci-rost') || '',
tac_na_grilovani_gourmet: button.getAttribute('data-product-tac-na-grilovani-gourmet') || '',
poklop_na_pokrm: button.getAttribute('data-product-poklop-na-pokrm') || '',
otocny_talir: button.getAttribute('data-product-otocny-talir') || '',
ulozeni_prislusenstvi: button.getAttribute('data-product-ulozeni-prislusenstvi') || '',
hubice_na_calouneni: button.getAttribute('data-product-hubice-na-calouneni') || '',
hubice_pro_vysavani_spar: button.getAttribute('data-product-hubice-pro-vysavani-spar') || '',
extra_dlouha_flexibilni_sparova_hubice_sfd_20: button.getAttribute('data-product-extra-dlouha-flexibilni-sparova-hubice-sfd-20') || '',
saci_stetec: button.getAttribute('data-product-saci-stetec') || '',
podlahova_hubice_sbd_355_3: button.getAttribute('data-product-podlahova-hubice-sbd-355-3') || '',
podlahova_hubice_sbd_365_3: button.getAttribute('data-product-podlahova-hubice-sbd-365-3') || '',
sbb_allfloor: button.getAttribute('data-product-sbb-allfloor') || '',
kartac_parquet_twister_sbb_300_3: button.getAttribute('data-product-kartac-parquet-twister-sbb-300-3') || '',
turbokartac_stb_305_3: button.getAttribute('data-product-turbokartac-stb-305-3') || '',
prachovy_sacek_hyclean_pure_tu: button.getAttribute('data-product-prachovy-sacek-hyclean-pure-tu') || '',
prachovy_sacek_hyclean_pure_co: button.getAttribute('data-product-prachovy-sacek-hyclean-pure-co') || '',
poukaz_na_prachove_sacky_hyclean_pure_tu: button.getAttribute('data-product-poukaz-na-prachove-sacky-hyclean-pure-tu') || '',
poukaz_na_prachove_sacky_hyclean_pure_co: button.getAttribute('data-product-poukaz-na-prachove-sacky-hyclean-pure-co') || '',
voucher_doplnkove_hepa_filtry: button.getAttribute('data-product-voucher-doplnkove-hepa-filtry') || '',
voucher_na_podlahovou_hubici_fiberteq_allfloor_sbd_380_3: button.getAttribute('data-product-voucher-na-podlahovou-hubici-fiberteq-allfloor-sbd-380-3') || '',
tri_kapsle: button.getAttribute('data-product-tri-kapsle') || '',
ultraphase_1_2: button.getAttribute('data-product-ultraphase-1-2') || '',
voucher_na_5_kartusi_praciho_prostredku_ultraphase_od_miele: button.getAttribute('data-product-voucher-na-5-kartusi-praciho-prostredku-ultraphase-od-miele') || '',
voucher_na_praci_prostredky_miele: button.getAttribute('data-product-voucher-na-praci-prostredky-miele') || '',
voucher_na_druhy_flakon_s_vuni: button.getAttribute('data-product-voucher-na-druhy-flakon-s-vuni') || '',
flakon_s_vuni: button.getAttribute('data-product-flakon-s-vuni') || '',

  rozmery_pristroje_s_x_v_x_h_v_mm: button.dataset.productRozmeryPristrojeSXVXHVMm || button.dataset.productRozmeryVXSXHVMm || '',
  rozmery_v_x_s_x_h_v_mm: button.dataset.productRozmeryVXSXHVMm || button.dataset.productRozmeryPristrojeSXVXHVMm || '',
  rozmery_v_mm_sirka: button.dataset.productRozmeryVMmSirka || '',
  rozmery_v_mm_vyska: button.dataset.productRozmeryVMmVyska || '',
  rozmery_v_mm_hloubka: button.dataset.productRozmeryVMmHloubka || '',
  hloubka_pristroje_s_otevrenymi_dvirky_v_mm: button.dataset.productHloubkaPristrojeSOtevrenymiDvirkyVMm || '',
  hloubka_pristroje_bez_dvirek_v_mm: button.dataset.productHloubkaPristrojeBezDvirekVMm || '',
  hmotnost_v_kg: button.dataset.productHmotnostVKg || '',
  napeti_ve_v: button.dataset.productNapetiVeV || '',
  typ_akumulatoru: button.dataset.productTypAkumulatoru || '',
  jmenovita_kapacita_akumulatoru_v_mah: button.dataset.productJmenovitaKapacitaAkumulatoruVMah || '',
  doba_provozu_na_stupen_min_powerunit_samostatne: button.dataset.productDobaProvozuNaStupenMinPowerunitSamostatne || '',
  doba_provozu_na_stupen_min_s_elektroprislusenstvim: button.dataset.productDobaProvozuNaStupenMinSElektroprislusenstvim || '',
  doba_provozu_na_stupen_max_s_elektroprislusenstvim: button.dataset.productDobaProvozuNaStupenMaxSElektroprislusenstvim || '',
  plosny_vykon_v_m: button.dataset.productPlosnyVykonVM || '',
  doba_nabijeni_v_min: button.dataset.productDobaNabijeniVMin || '',
  jisteni_v_a: button.dataset.productJisteniVA || '',
  frekvence_v_hz: button.dataset.productFrekvenceVHz || '',
  celkovy_prikon_v_kw: button.dataset.productCelkovyPrikonVKw || '',
  delka_privodni_hadice_v_m: button.dataset.productDelkaPrivodniHadiceVM || '',
  delka_vypousteci_hadice_v_m: button.dataset.productDelkaVypousteciHadiceVM || '',
delka_elektrickeho_privodniho_kabelu_v_m: button.dataset.productDelkaElektrickehoPrivodnihoKabeluVM || '',
delka_odtokove_hadice_v_m: button.dataset.productDelkaOdtokoveHadiceVM || button.dataset.productDelkaVypousteciHadiceVM || '',
min_vyska_nad_elektrickou_varnou_deskou_v_mm: button.getAttribute('data-product-min-vyska-nad-elektrickou-varnou-deskou-v-mm') || '',
min_bezpecna_vzdalenost_nad_plynovymi_varnymi_deskami_celkovy_vy: button.getAttribute('data-product-min-bezpecna-vzdalenost-nad-plynovymi-varnymi-deskami-celkovy-vy') || '',
celkova_vyska_odsavace_pri_odtahu_a_externim_provedeni_v_mm_mini: button.getAttribute('data-product-celkova-vyska-odsavace-pri-odtahu-a-externim-provedeni-v-mm-mini') || '',
celkova_vyska_odsavace_pri_odtahu_a_externim_provedeni_v_mm_maxi: button.getAttribute('data-product-celkova-vyska-odsavace-pri-odtahu-a-externim-provedeni-v-mm-maxi') || '',
celkova_vyska_odsavace_pri_cirkulaci_v_mm_minimum: button.getAttribute('data-product-celkova-vyska-odsavace-pri-cirkulaci-v-mm-minimum') || '',
celkova_vyska_odsavace_pri_cirkulaci_v_mm_maximum: button.getAttribute('data-product-celkova-vyska-odsavace-pri-cirkulaci-v-mm-maximum') || '',
celkova_vyska_odsavace_v_odtahu_a_v_externim_provedeni_v_mm: button.getAttribute('data-product-celkova-vyska-odsavace-v-odtahu-a-v-externim-provedeni-v-mm') || '',
celkova_vyska_odsavace_par_v_cirkulacnim_provozu_v_mm: button.getAttribute('data-product-celkova-vyska-odsavace-par-v-cirkulacnim-provozu-v-mm') || '',
hermeticky_uzavreno: button.dataset.productHermetickyUzavreno || '',
  typ_chladiva: button.dataset.productTypChladiva || '',
  mnozstvi_chladiva_v_kg: button.dataset.productMnozstviChladivaVKg || '',
  potencial_globalniho_oteplovani_chladiva_v_co_e: button.getAttribute('data-product-potencial-globalniho-oteplovani-chladiva-v-co-e') || button.dataset.productPotencialGlobalnihoOteplovaniChladivaVCoE || '',
  potencial_globalniho_oteplovani_pristroje_v_co_e: button.getAttribute('data-product-potencial-globalniho-oteplovani-pristroje-v-co-e') || button.dataset.productPotencialGlobalnihoOteplovaniPristrojeVCoE || '',
  dostupne_jazyky_displeje_diky_multilingua: button.dataset.productDostupneJazykyDisplejeDikyMultilingua || ''
};

    let compareItems = window.getCompareItems();

    const existingIndex = compareItems.findIndex(function(item) {
      return String(item.id) === String(product.id);
    });

if (existingIndex > -1) {
  compareItems.splice(existingIndex, 1);
} else {
  if (
    compareItems.length > 0 &&
    compareItems[0].compare_category &&
    compareItems[0].compare_category !== product.compare_category
  ) {
    alert('Lze porovnávat pouze produkty stejného typu.');
    return;
  }

  if (compareItems.length >= 3) {
    alert('Lze porovnat maximálně 3 produkty.');
    return;
  }

  compareItems.push(product);
}

 localStorage.setItem('product_compare_items_v2', JSON.stringify(compareItems));
window.dispatchEvent(new CustomEvent('compare:updated'));

  refreshCompareUi();
  });

document.addEventListener('DOMContentLoaded', function() {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(function() {
      refreshCompareUi();
    });
  } else {
    setTimeout(function() {
      refreshCompareUi();
    }, 500);
  }
});

document.addEventListener('shopify:section:load', function() {
  refreshCompareUi();
});